import { mutatorAction } from 'satcheljs';
import getWeatherOption from '../store/store';
export default mutatorAction('selectWeatherUnitOption', function selectWeatherUnitOption(weatherUnit) {
    var optionState = getWeatherOption();
    optionState.weatherUnit = weatherUnit;
});
//# sourceMappingURL=selectWeatherUnitOption.js.map